import { required } from 'AppReact/schema';

export default {
  isVisible: required('boolean'),
  isEdit: required('boolean'),
}

export const defaultNewInspectionModal = {
  isVisible: false,
  isEdit: false
}